import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";

const AuthErrorPage = () => {
  const [params] = useSearchParams();

  useEffect(() => {
    const error = params.get("error") || "default";
    window.location.replace(`/?authError=${encodeURIComponent(error)}`);
  }, [params]);

  return (
    <div className="flex min-h-screen items-center justify-center text-sm text-muted-foreground">
      Returning you to the site…
    </div>
  );
};

export default AuthErrorPage;
